import clsx from 'clsx';
import { CSSProperties, forwardRef } from 'react';

import styles from './color-indicator.module.scss';

export const ColorIndicator = forwardRef((props: ColorIndicatorProps, ref: any) => {
  const { color, onClick, selected, className, size = 'default', ...rest } = props;

  const selectable = !!onClick;

  if (size === 'tiny') {
    return (
      <div ref={ref} className={clsx(styles.colorIndicatorMini, className)} role="presentation" data-color={color} {...rest}>
        <div className={styles.outershell}>
          <div className={styles.color} style={{ ['--color']: color } as CSSProperties} />
        </div>
      </div>
    );
  }

  return (
    <button
      {...rest}
      ref={ref}
      data-color={color}
      data-selected={selected}
      style={{ ['--color']: color } as CSSProperties}
      onClick={selectable ? () => onClick?.(color) : undefined}
      className={clsx(styles.colorIndicator, 'color-indicator', className, styles[`s-${size}`], {
        [styles.selected]: selected,
        [styles.selectable]: selectable,
      })}
    />
  );
});

export interface ColorIndicatorProps {
  color: string;
  selected?: boolean;
  className?: string;
  onClick?: (color: string) => void;
  size?: 'default' | 'tiny' | 'small' | 'big';
}
